import React from 'react';
import { Spinner } from '@/components/ui/spinner';

interface ChartLoaderProps {
  height?: number;
}

export const ChartLoader = ({ height = 300 }: ChartLoaderProps) => {
  return (
    <div
      className="relative flex items-center justify-center bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded border border-gray-200 dark:border-gray-700"
      style={{ height }}
    >
      {/* Overlay with opacity */}
      <div className="absolute inset-0 bg-white/60 dark:bg-gray-800/60 rounded" />

      {/* 3D Cube spinner with logo */}
      <div className="relative z-10">
        <Spinner size="sm" />
      </div>
    </div>
  );
};
